import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { careersContact } from '@core/models/interfaces/careersContact/careersContact';
@Injectable({
  providedIn: 'root',
})
export class CareersService {
  constructor(private __http: HttpClient) {}

  getAllCareers(): Observable<any> {
    return this.__http
      .get<any>(`${environment.url}careers`)
      .pipe(map((res: any) => res.data));
  }
  getCareer(slug: string): Observable<any> {
    return this.__http
      .get<any>(`${environment.url}career-pages?filters[slug][$eq]=${slug}`)
      .pipe(map((res: any) => res.data));
  }

  sendCareersContact(formValue: any): Observable<any> {
    const formData = new FormData();
    formData.append('name', formValue.name);
    formData.append('email', formValue.email);
    formData.append('number', formValue.number);
    formData.append('salary', formValue.salary);
    formData.append('job', formValue.job || 'designer');
    formData.append('message', formValue.message);
  
    if (formValue.attachment && formValue.attachment instanceof File) {
      formData.append('attachment', formValue.attachment, formValue.attachment.name);
    } else {
      console.warn('Invalid or missing file');
    }
  
    return this.__http.post(`${environment.url}career-contacts`, formData);
  }
  
    
    
}
